// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3XqPq","header":"PatientQuestionnaire_header__b2mQu","info":"PatientQuestionnaire_info__1uMo6"};